<template>
  <div style="width:90%">
    <div class="">
      <b-table class="" striped hover :items="items" :fields="fields">
        <template v-slot:cell(item_name)="row">
          <span class="link mr-1" @click.stop="drillDownCallback(row.item)">{{row.item.item_name}}</span>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SalesViewList',
  components: {
    
  },
  data: function () {
    return {
      
    }
  },
  props: [
      'items',
      'fields',
      'drillDownCallback'
    ],
  methods: {
    
  },
  computed: {
    
  },
  mounted () {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.link {
  text-decoration: underline;
}

.link:hover {
  cursor: pointer;;
  color:blue;
}

</style>
